import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { observer } from 'mobx-react'
import { Button, ContentWrapper, Spacer } from '~/components/elements'
import { ArrowBackIosOutlineIcon } from '~/components/icons'
import { OutagesComponent } from '~/components/outages/Outages'
import { useRootStore } from '~/store/RootStore'

const OutagesPage = observer(() => {
  const navigate = useNavigate({ from: '/home' })
  const { account } = useRootStore()
  const currentService = account.getCurrentService

  return (
    <ContentWrapper>
      <Button
        size="small"
        variant="secondary"
        onClick={() => navigate({ to: '/home' })}
      >
        <ArrowBackIosOutlineIcon /> Back
      </Button>
      <Spacer height="12px" />
      <OutagesComponent currentService={currentService} />
    </ContentWrapper>
  )
})

export const Route = createFileRoute('/_authenticated/home/outages')({
  component: OutagesPage,
})
